export class DigitalProjection {
    constructor(socket) {
        this.socket = socket;
        this.displayBlank = false;
        this.displayFreeze = false;
        this.firmwareVersion = 'EV-9000 LX766-K85DPEA-V04';
        this.power = false;
        this.videoInput = '6';
        this.asyncHandlers = [
            {
                name: 'displayBlankQuery',
                regExp: /\*blanking\.enable \?/i,
                callback: (match) => {
                    this.socket.send(`${this.displayBlank ? '1' : '0'}`);
                },
            },
            {
                name: 'displayBlankSet',
                regExp: /\*blanking\.enable = (.+)/i,
                callback: (match) => {
                    this.displayBlank = match[1] === 'ON';
                    this.socket.send(`ACK blanking.enable = ${this.displayBlank ? '1' : '0'}`);
                },
            },
            {
                name: 'displayBlankQueryE9000',
                regExp: /op\s+blank\s*\?/i,
                callback: (match) => {
                    this.socket.send(`op blank = ${this.displayBlank ? 1 : 0}`);
                },
            },
            {
                name: 'displayBlankSetE9000',
                regExp: /op\s+blank\s*=\s*(.+)/i,
                callback: (match) => {
                    this.displayBlank = match[1] === '1';
                    this.socket.send(`op blank = ${this.displayBlank ? 1 : 0}`);
                },
            },
            {
                name: 'displayFreezeQuery',
                regExp: /\*freeze\s*\?/i,
                callback: (match) => {
                    this.socket.send(`${this.displayFreeze ? 1 : 0}`);
                },
            },
            {
                name: 'displayFreezeSet',
                regExp: /\*freeze\s*=\s*(.+)/i,
                callback: (match) => {
                    this.displayFreeze = match[1] === 'ON' || match[1] === '1';
                    this.socket.send(`ACK freeze = ${this.displayFreeze ? 1 : 0}`);
                },
            },
            {
                name: 'displayFreezeQueryE9000',
                regExp: /op\s+freeze\s*\?/i,
                callback: (match) => {
                    this.socket.send(`op freeze = ${this.displayFreeze ? '1' : '0'}`);
                },
            },
            {
                name: 'displayFreezeSetE9000',
                regExp: /op\s+freeze\s*=\s*(.+)/i,
                callback: (match) => {
                    this.displayFreeze = match[1] === 'ON' || match[1] === '1';
                    this.socket.send(`op freeze = ${this.displayFreeze ? '1' : '0'}`);
                },
            },
            {
                name: 'firmwareVersionE9000',
                regExp: /op\s+sw\.ver\s*\?/i,
                callback: (match) => {
                    this.socket.send(`op sw.ver = ${this.firmwareVersion}`);
                },
            },
            {
                name: 'firmwareVersion',
                regExp: /\*sw\.version\s*\?/i,
                callback: (match) => {
                    this.socket.send(`${this.firmwareVersion}`);
                },
            },
            {
                name: 'powerQuery',
                regExp: /\*power\s*\?/i,
                callback: (match) => {
                    this.socket.send(`${this.power ? 'ON' : 'OFF'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /\*power\s*=\s*(.+)/i,
                callback: (match) => {
                    this.power = match[1] === 'ON';
                    this.socket.send(`ACK power = ${this.power ? 'ON' : 'OFF'}`);
                },
            },
            {
                name: 'powerQueryE9000',
                regExp: /op\s+status\s*\?/i,
                callback: (match) => {
                    this.socket.send(`OP STATUS = ${this.power ? '2' : '0'}`);
                },
            },
            {
                name: 'powerSetE9000',
                regExp: /op\s+power\.(on|off)/i,
                callback: (match) => {
                    this.power = match[1].toUpperCase() === 'ON';
                    this.socket.send(`OP POWER${this.power ? '.ON' : '.OFF'}`);
                },
            },
            {
                name: 'videoInputQuery',
                regExp: /\*input\s*\?/i,
                callback: (match) => {
                    this.socket.send(`${this.videoInput}`);
                },
            },
            {
                name: 'videoInputSet',
                regExp: /\*input\s*=\s*(.+)/i,
                callback: (match) => {
                    this.videoInput = match[1];
                    this.socket.send(`ACK input = ${this.videoInput}`);
                },
            },
            {
                name: 'videoInputQueryE9000',
                regExp: /op\s+input\.sel\s*\?/i,
                callback: (match) => {
                    this.socket.send(`op input.sel = ${this.videoInput}`);
                },
            },
            {
                name: 'videoInputSetE9000',
                regExp: /op\s+input\.sel\s*=\s*(.+)/i,
                callback: (match) => {
                    this.videoInput = match[1];
                    this.socket.send(`op input.sel = ${this.videoInput}`);
                },
            },
            {
                name: 'commandError',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`*Illegal format#`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            if (this.videoInput === videoInput.code)
                return;
            if (lowestCode === undefined ||
                parseInt(videoInput.code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = videoInput.code;
            }
        }
        this.videoInput = lowestCode !== null && lowestCode !== void 0 ? lowestCode : '6';
    }
}
DigitalProjection.emulatorType = 'socketEmulator';
DigitalProjection.key = '-N30OlyFFprpetBntqQN';
